import actionTypes from 'SRC/modules/redux/actionTypes'

export const setParentCategory = (category) => {
  return {
    type: actionTypes.SET_PARENT_CATEGORY,
    payload: category
  }
}
